export default __webpack_public_path__ + "static/media/p4.ec9e50de.jpg";